export const TAB_KEY_RESTAURANTGROUP = 'restaurantGroup';
export const TAB_KEY_RESTAURANT = 'restaurant';
